(() => {
  // ===== CONFIG =====
  const WRAP_SELECTOR = "[data-bb-embroidery-preview]";

  const SHOPIFY_SWEATER_OPTION = "Preferred Sweater Color";
  const EASIFY_THREAD_LABEL = "Thread Colour";
  const EASIFY_GLITTER_LABEL = "Glitter Colour";
  // const EASIFY_DESIGN_LABEL = "Embroidered Design"; // ❌ no longer used

  const EASIFY_GLITTER_TOGGLE_LABEL = "Glitter Applique";
  const EASIFY_GLITTER_TOGGLE_YES = "Yes Please!";

  const LEFT_PLACEMENT  = { x: 0.25, y: 0.320, w: 0.35 };
  const RIGHT_PLACEMENT = { x: 0.76, y: 0.330, w: 0.35 };

  // ✅ Mobile-only placement tweaks (Option B)
  const MOBILE_X_NUDGE = 0.00;   // + right, - left
  const MOBILE_Y_NUDGE = 0.02;   // + down,  - up
  const MOBILE_W_SCALE = 0.92;   // <1 smaller, >1 bigger (start 0.92)

  const DISABLE_RIGHT_PREVIEW = ["Heather Navy", "Orchid"];
  const OUTLINE_THICKNESS = 0.0025;

  const FILL_ALPHA = 0.92;
  const GLITTER_SCALE = 0.32;

  const EMBOSS_ENABLED = false;
  const EMBOSS_DEPTH_PX = 2.5;
  const EMBOSS_BLUR_PX  = 3.5;
  const EMBOSS_HI_ALPHA = 0.18;
  const EMBOSS_SH_ALPHA = 0.22;
  const GLOSS_ALPHA     = 0.10;

  const THREAD_EMBROIDERY_ENABLED = false;
  const THREAD_FILL_BAND_ALPHA = 0.85;
  const THREAD_STITCH_ALPHA    = 0.22;
  const THREAD_STITCH_SCALE    = 1.0;
  const THREAD_BEVEL_HI_ALPHA  = 0.22;
  const THREAD_BEVEL_SH_ALPHA  = 0.25;
  const THREAD_BEVEL_BLUR_PX   = 2.2;

  // ✅ NEW: Defaults if the Liquid block doesn't set them
  // Use EITHER bbDesign (key into window.BB_DESIGN_ASSETS)
  // OR bbOutline+bbFill (direct URLs). Direct URLs win.
  const DEFAULT_DESIGN_KEY = ""; // e.g. "Dog Mom" (optional)

  const SWEATER_COLORS = {
    "White":"#ffffff","Ash":"#d8d8d8","Sport Grey":"#cfcfcf","Charcoal":"#4b4b4b",
    "Dark Heather":"#3a3a3a","Black":"#000000","Sand":"#c9b39a","Light Blue":"#bcd3ea",
    "Carolina Blue":"#7fa9d9","Royal":"#1e5bb8","Heather Navy":"#3f4f6b","Navy":"#1a2540",
    "Orchid":"#d2c0e6","Light Pink":"#f6c7d7","Safety Pink":"#ff6a8c","Meliconia":"#e02672",
    "Gold":"#f1b21c","Orange":"#f07c00","Red":"#e61e1e","Maroon":"#6d0e24",
    "Irish Green":"#1ea35b","Military Green":"#5b614a","Forest":"#203a2c","Dark Chocolate":"#2a1b14"
  };

  const THREAD_COLORS = {
    "White":"#ffffff","Silver Grey":"#d1cdc8","Black":"#252726","Spearmint":"#7db2bb","Aqua":"#459caa",
    "Island Green":"#5fb0bd","Marine Aqua":"#0e6a75","California Blue":"#118cc2","Wedgewood":"#7285a3","Sapphire":"#2d2f61",
    "Amethyst":"#6a5671","Sugar Plum":"#86457f","Wild Iris":"#724176","Purple":"#523d74","Deep Purple":"#3b1d49",
    "Carnation":"#e59eaa","Pink Tulip":"#e2807f","Tropicana":"#ca3456","Garden Rose":"#c02a5f","Fuchsia":"#951a3e",
    "Yellow":"#e7bf42","Coral":"#ee714b","Orange":"#dc5d25","Tantone":"#d7a06a","Red":"#b61f23","Burgundy":"#661213",
    "Mint":"#b1c86e","Erin Green":"#849b4a","Pear":"#689d52","Palm Leaf":"#464c42","Backyard Green":"#182b17",
    "Brown":"#86674b"
  };

  // ===== HELPERS =====
  function $(sel, root = document) { return root.querySelector(sel); }
  function $all(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }
  function normalize(s) {
    return String(s || "").toLowerCase().replace(/\s+/g, " ").replace(/[*:]/g, "").trim();
  }

  // ✅ Canvas finder: works with id, class, or plain <canvas>
  function getCanvasFromWrap(wrap){
    return (
      wrap.querySelector("#bbEmbroideryCanvas") ||
      wrap.querySelector(".bbEmbroideryCanvas") ||
      wrap.querySelector("canvas")
    );
  }

  // ===== OPTION READERS =====
  // ✅ Shopify option reader that also works with Dawn/variant-picker
  function getShopifyOptionValue(optionName) {
    const target = normalize(optionName);

    // 1) Standard options[Name]
    const optionFields = $all('input[name^="options["], select[name^="options["]');
    for (const el of optionFields) {
      const name = el.getAttribute("name") || "";
      const inside = name.match(/^options\[(.*)\]$/i)?.[1] || "";
      if (normalize(inside) !== target) continue;

      if (el.tagName === "INPUT" && el.type === "radio") {
        const checked = document.querySelector(`input[name="${CSS.escape(name)}"]:checked`);
        const v = (checked?.value || "").trim();
        if (v) return v;
      } else {
        const v = (el.value || "").trim();
        if (v) return v;
      }
    }

    // 2) Fieldset legend match (Dawn style)
    for (const fs of $all("fieldset")) {
      const legend = $("legend", fs);
      if (!legend) continue;
      if (!normalize(legend.textContent || "").includes(target)) continue;

      const checked = $('input[type="radio"]:checked', fs);
      if (checked?.value) return checked.value;

      const select = $("select", fs);
      if (select?.value) return select.value;
    }

    // 3) Fallback: option1/option2/option3
    const opt1 =
      $('input[name="option1"]:checked')?.value ||
      $('select[name="option1"]')?.value ||
      null;

    return opt1 ? String(opt1).trim() : null;
  }

  function getEasifyPropertyValue(label) {
    const target = normalize(label);
    const fields = $all('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');

    // exact match
    for (const el of fields) {
      const name = el.getAttribute("name") || "";
      const inside = name.match(/^properties\[(.*)\]$/i)?.[1] || "";
      if (normalize(inside) !== target) continue;

      if (el.tagName === "INPUT" && el.type === "radio") {
        const checked = document.querySelector(`input[name="${CSS.escape(name)}"]:checked`);
        const v = (checked?.value || "").trim();
        if (v) return v;
      } else {
        const v = String(el.value || "").trim();
        if (v) return v;
      }
    }

    // partial match
    for (const el of fields) {
      const name = el.getAttribute("name") || "";
      const inside = name.match(/^properties\[(.*)\]$/i)?.[1] || "";
      if (!normalize(inside).includes(target)) continue;

      if (el.tagName === "INPUT" && el.type === "radio") {
        const checked = document.querySelector(`input[name="${CSS.escape(name)}"]:checked`);
        const v = (checked?.value || "").trim();
        if (v) return v;
      } else {
        const v = String(el.value || "").trim();
        if (v) return v;
      }
    }

    return null;
  }

  function isGlitterEnabled() {
    const v = (getEasifyPropertyValue(EASIFY_GLITTER_TOGGLE_LABEL) || "").trim();
    return normalize(v) === normalize(EASIFY_GLITTER_TOGGLE_YES);
  }

  // ===== ✅ DESIGN OVERRIDE (from Custom Liquid block) =====
  // In your Liquid block, set ONE of:
  // 1) data-bb-design="Dog Mom"  (key in window.BB_DESIGN_ASSETS)
  // OR
  // 2) data-bb-outline="...png" data-bb-fill="...png" (direct URLs)
  function getSelectedDesignKey(wrap) {
    const fromData = (wrap?.dataset?.bbDesign || "").trim();
    if (fromData) return fromData;
    return DEFAULT_DESIGN_KEY; // optional fallback
  }

  function getDesignAssetSet(wrap) {
    // Direct URL override wins
    const outlineFromData = (wrap?.dataset?.bbOutline || "").trim();
    const fillFromData    = (wrap?.dataset?.bbFill || "").trim();
    if (outlineFromData && fillFromData) {
      return { outline: outlineFromData, fill: fillFromData };
    }

    // Otherwise, use bbDesign key into the global map
    const key = getSelectedDesignKey(wrap);
    const map = window.BB_DESIGN_ASSETS || {};

    // exact
    if (map[key]?.outline && map[key]?.fill) return map[key];

    // normalized match
    const keyNorm = normalize(key);
    const found = Object.keys(map).find(k => normalize(k) === keyNorm);
    if (found && map[found]?.outline && map[found]?.fill) return map[found];

    // fallback
    return {
      outline: window.BB_VARSITY_OUTLINE_URL || null,
      fill: window.BB_VARSITY_FILL_URL || null
    };
  }

  // ===== IMAGE CACHING =====
  const imageCache = new Map();
  const patternCache = new Map();
  const threadPatternCache = new Map();

  function loadImage(src) {
    if (!src) return Promise.resolve(null);
    if (imageCache.has(src)) return Promise.resolve(imageCache.get(src));
    return new Promise((res) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => { imageCache.set(src, img); res(img); };
      img.onerror = () => res(null);
      img.src = src;
    });
  }

  async function loadMockupForColour(colourName) {
    const map = window.BB_SWEATER_MOCKUP_URLS || {};
    return loadImage(map[colourName]);
  }

  async function loadDesignOutline(wrap) { return loadImage(getDesignAssetSet(wrap).outline); }
  async function loadDesignFill(wrap)    { return loadImage(getDesignAssetSet(wrap).fill); }

  // ===== CANVAS / DRAW =====
  function setCanvasToSize(canvas) {
    const rect = canvas.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    const w = Math.max(1, Math.round(rect.width * dpr));
    const h = Math.max(1, Math.round(rect.height * dpr));
    if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
    return { W: rect.width, H: rect.height, dpr };
  }

  function drawCover(ctx, img, W, H) {
    const iw = img.width, ih = img.height;

    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    const SAFE_SCALE = isMobile ? 0.88 : 0.99; // zoom out more on mobile

    const scale = Math.max(W / iw, H / ih) * SAFE_SCALE;
    const dw = iw * scale;
    const dh = ih * scale;
    const dx = (W - dw) / 2;
    const dy = (H - dh) / 2;

    ctx.drawImage(img, dx, dy, dw, dh);
  }

  function drawTintMask(ctx, maskImg, x, y, w, h, color) {
    const off = document.createElement("canvas");
    off.width = Math.max(1, Math.round(w));
    off.height = Math.max(1, Math.round(h));
    const o = off.getContext("2d");
    o.clearRect(0, 0, off.width, off.height);
    o.drawImage(maskImg, 0, 0, off.width, off.height);
    o.globalCompositeOperation = "source-in";
    o.fillStyle = color;
    o.fillRect(0, 0, off.width, off.height);
    ctx.drawImage(off, x, y, w, h);
  }

  function drawPatternMask(ctx, maskImg, x, y, w, h, pattern, alpha = 1) {
    const off = document.createElement("canvas");
    off.width = Math.max(1, Math.round(w));
    off.height = Math.max(1, Math.round(h));
    const o = off.getContext("2d");
    o.clearRect(0, 0, off.width, off.height);
    o.drawImage(maskImg, 0, 0, off.width, off.height);
    o.globalCompositeOperation = "source-in";
    o.fillStyle = pattern;
    o.fillRect(0, 0, off.width, off.height);

    if (alpha < 1) {
      const off2 = document.createElement("canvas");
      off2.width = off.width;
      off2.height = off.height;
      const o2 = off2.getContext("2d");
      o2.globalAlpha = alpha;
      o2.drawImage(off, 0, 0);
      ctx.drawImage(off2, x, y, w, h);
    } else {
      ctx.drawImage(off, x, y, w, h);
    }
  }

  async function getGlitterPattern(ctx, glitterName) {
    if (!glitterName) return null;
    const urlMap = window.BB_GLITTER_ASSET_URLS || {};
    const src = urlMap[glitterName];
    if (!src) return null;

    const cacheKey = `${src}__scale_${GLITTER_SCALE}`;
    if (patternCache.has(cacheKey)) return patternCache.get(cacheKey);

    const img = await loadImage(src);
    if (!img) return null;

    const scaled = document.createElement("canvas");
    scaled.width = Math.max(1, Math.round(img.width * GLITTER_SCALE));
    scaled.height = Math.max(1, Math.round(img.height * GLITTER_SCALE));

    const sctx = scaled.getContext("2d");
    sctx.imageSmoothingEnabled = true;
    sctx.drawImage(img, 0, 0, scaled.width, scaled.height);

    const pattern = ctx.createPattern(scaled, "repeat");
    patternCache.set(cacheKey, pattern);
    return pattern;
  }

  function drawEmbossedGlitterFill(ctx, fillImg, x, y, w, h, pattern) {
    drawPatternMask(ctx, fillImg, x, y, w, h, pattern, FILL_ALPHA);
    if (!EMBOSS_ENABLED) return;

    const prevFilter = ctx.filter;

    ctx.save();
    ctx.globalAlpha = EMBOSS_SH_ALPHA;
    ctx.filter = `blur(${EMBOSS_BLUR_PX}px)`;
    drawTintMask(ctx, fillImg, x + EMBOSS_DEPTH_PX, y + EMBOSS_DEPTH_PX, w, h, "#000");
    ctx.restore();

    ctx.save();
    ctx.globalAlpha = EMBOSS_HI_ALPHA;
    ctx.filter = `blur(${EMBOSS_BLUR_PX}px)`;
    drawTintMask(ctx, fillImg, x - EMBOSS_DEPTH_PX, y - EMBOSS_DEPTH_PX, w, h, "#fff");
    ctx.restore();

    ctx.save();
    ctx.globalAlpha = GLOSS_ALPHA;
    ctx.filter = `blur(${Math.max(1, Math.round(EMBOSS_BLUR_PX * 1.2))}px)`;

    const off = document.createElement("canvas");
    off.width = Math.max(1, Math.round(w));
    off.height = Math.max(1, Math.round(h));
    const o = off.getContext("2d");
    o.drawImage(fillImg, 0, 0, off.width, off.height);
    o.globalCompositeOperation = "source-in";

    const grad = o.createLinearGradient(0, 0, off.width, off.height);
    grad.addColorStop(0.0, "rgba(255,255,255,0.70)");
    grad.addColorStop(0.35,"rgba(255,255,255,0.00)");
    grad.addColorStop(0.65,"rgba(255,255,255,0.00)");
    grad.addColorStop(1.0, "rgba(255,255,255,0.45)");
    o.fillStyle = grad;
    o.fillRect(0, 0, off.width, off.height);

    ctx.drawImage(off, x, y, w, h);
    ctx.restore();

    ctx.filter = prevFilter;
  }

  function makeStitchPattern(ctx, color) {
    const key = `${color}__${THREAD_STITCH_SCALE}`;
    if (threadPatternCache.has(key)) return threadPatternCache.get(key);

    const c = document.createElement("canvas");
    const s = Math.max(18, Math.round(22 * THREAD_STITCH_SCALE));
    c.width = s; c.height = s;
    const g = c.getContext("2d");

    g.clearRect(0, 0, s, s);
    g.globalAlpha = 0.10;
    g.fillStyle = color;
    g.fillRect(0, 0, s, s);

    g.globalAlpha = 0.35;
    g.strokeStyle = color;
    g.lineWidth = Math.max(1, Math.round(s * 0.10));
    g.lineCap = "round";

    for (let i = -s; i < s * 2; i += Math.max(6, Math.round(7 * THREAD_STITCH_SCALE))) {
      g.beginPath();
      g.moveTo(i, 0);
      g.lineTo(i + s, s);
      g.stroke();
    }

    const pat = ctx.createPattern(c, "repeat");
    threadPatternCache.set(key, pat);
    return pat;
  }

  function drawThreadBand(ctx, outlineImg, x, y, w, h, threadColor) {
    const pattern = makeStitchPattern(ctx, threadColor);

    ctx.save();
    ctx.globalAlpha = THREAD_FILL_BAND_ALPHA;
    drawPatternMask(ctx, outlineImg, x, y, w, h, pattern, 1);
    ctx.restore();

    const prevFilter = ctx.filter;

    ctx.save();
    ctx.globalAlpha = THREAD_BEVEL_HI_ALPHA;
    ctx.filter = `blur(${THREAD_BEVEL_BLUR_PX}px)`;
    drawTintMask(ctx, outlineImg, x - 1.5, y - 1.5, w, h, "#fff");
    ctx.restore();

    ctx.save();
    ctx.globalAlpha = THREAD_BEVEL_SH_ALPHA;
    ctx.filter = `blur(${THREAD_BEVEL_BLUR_PX}px)`;
    drawTintMask(ctx, outlineImg, x + 1.8, y + 1.8, w, h, "#000");
    ctx.restore();

    ctx.save();
    ctx.globalAlpha = THREAD_STITCH_ALPHA;
    ctx.globalCompositeOperation = "multiply";
    drawPatternMask(ctx, outlineImg, x, y, w, h, pattern, 1);
    ctx.restore();

    ctx.filter = prevFilter;
  }

  function stampOutline(ctx, outlineImg, x, y, w, h, color, thicknessPx) {
    if (THREAD_EMBROIDERY_ENABLED) {
      drawThreadBand(ctx, outlineImg, x, y, w, h, color);
      const t = Math.max(1, Math.round(thicknessPx));
      const offsets = [[-t,0],[t,0],[0,-t],[0,t]];
      for (const [dx,dy] of offsets) drawTintMask(ctx, outlineImg, x+dx, y+dy, w, h, color);
      drawTintMask(ctx, outlineImg, x, y, w, h, color);
      return;
    }
    drawTintMask(ctx, outlineImg, x, y, w, h, color);
  }

  function drawDesignAt(ctx, outlineImg, fillImg, centerX, centerY, targetW, fillPattern, strokeColor, outlinePx) {
    const w = targetW;
    const h = w * (outlineImg.height / outlineImg.width);
    const x = centerX - (w / 2);
    const y = centerY - (h / 2);

    stampOutline(ctx, outlineImg, x, y, w, h, strokeColor, outlinePx);
    if (fillPattern) drawEmbossedGlitterFill(ctx, fillImg, x, y, w, h, fillPattern);
  }

  // ===== RENDER =====
  const renderState = new WeakMap();

  async function renderOne(wrap) {
    const canvas = getCanvasFromWrap(wrap);
    if (!canvas) {
      console.warn("[BB Preview] Canvas not found inside wrap:", wrap);
      return;
    }

    const ctx = canvas.getContext("2d");
    const { W, H, dpr } = setCanvasToSize(canvas);
    if (W < 5 || H < 5) return;

    const prev = renderState.get(wrap) || { token: 0 };
    const token = prev.token + 1;
    renderState.set(wrap, { token });

    ctx.setTransform(1,0,0,1,0,0);
    ctx.scale(dpr, dpr);
    ctx.clearRect(0,0,W,H);

    const sweaterName = getShopifyOptionValue(SHOPIFY_SWEATER_OPTION) || "White";
    const threadName  = getEasifyPropertyValue(EASIFY_THREAD_LABEL) || "Black";

    const glitterOn = isGlitterEnabled();
    const glitterName = glitterOn ? (getEasifyPropertyValue(EASIFY_GLITTER_LABEL) || null) : null;

    // ✅ DEBUG (you’ll see it in console)
    console.log("[BB Preview values]", {
      sweaterName,
      designKey: getSelectedDesignKey(wrap),
      outlineUrl: (wrap?.dataset?.bbOutline || "").trim() || null,
      fillUrl: (wrap?.dataset?.bbFill || "").trim() || null,
      threadName,
      glitterOn,
      glitterName
    });

    const mockup = await loadMockupForColour(sweaterName);
    if ((renderState.get(wrap)?.token || 0) !== token) return;

    if (mockup) drawCover(ctx, mockup, W, H);
    else {
      ctx.fillStyle = SWEATER_COLORS[sweaterName] || "#fff";
      ctx.fillRect(0,0,W,H);
    }

    // ✅ UPDATED: pass wrap so it can read data-bb-design / data-bb-outline / data-bb-fill
    const [outlineImg, fillImg] = await Promise.all([
      loadDesignOutline(wrap),
      loadDesignFill(wrap)
    ]);
    if ((renderState.get(wrap)?.token || 0) !== token) return;
    if (!outlineImg || !fillImg) return;

    const pattern = glitterOn ? await getGlitterPattern(ctx, glitterName) : null;
    if ((renderState.get(wrap)?.token || 0) !== token) return;

    const strokeColor = THREAD_COLORS[threadName] || "#111";
    const outlinePx = Math.max(1, Math.round(Math.min(W,H) * OUTLINE_THICKNESS));

    // ✅ Option B: mobile-only nudges/scaling for design placement
    const isMobilePlacement = window.matchMedia("(max-width: 749px)").matches;
    const xNudge = isMobilePlacement ? MOBILE_X_NUDGE : 0;
    const yNudge = isMobilePlacement ? MOBILE_Y_NUDGE : 0;
    const wScale = isMobilePlacement ? MOBILE_W_SCALE : 1;

    const LP = {
      x: LEFT_PLACEMENT.x + xNudge,
      y: LEFT_PLACEMENT.y + yNudge,
      w: LEFT_PLACEMENT.w * wScale
    };

    const RP = {
      x: RIGHT_PLACEMENT.x + xNudge,
      y: RIGHT_PLACEMENT.y + yNudge,
      w: RIGHT_PLACEMENT.w * wScale
    };

    drawDesignAt(
      ctx, outlineImg, fillImg,
      W * LP.x, H * LP.y, W * LP.w,
      pattern, strokeColor, outlinePx
    );

    if (!DISABLE_RIGHT_PREVIEW.includes(sweaterName)) {
      drawDesignAt(
        ctx, outlineImg, fillImg,
        W * RP.x, H * RP.y, W * RP.w,
        pattern, strokeColor, outlinePx
      );
    }
  }

  let timer;
  function safeRenderAll() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      $all(WRAP_SELECTOR).forEach(w => renderOne(w).catch(()=>{}));
    }, 120);
  }

  function boot() {
    safeRenderAll();
    document.addEventListener("change", safeRenderAll, true);
    document.addEventListener("click", safeRenderAll, true);
    window.addEventListener("resize", safeRenderAll);
    const obs = new MutationObserver(() => safeRenderAll());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
